export function calculateItemTotalPrice(item, orderType = 'dine_in') {
    if (!item.selectedSize)
        return 0;
    const isDelivery = orderType === 'delivery';
    let basePrice = 0;
    if (isDelivery) {
        basePrice =
            Number(item.selectedSize.priceLivraison) ||
                Number(item.selectedSize.price) ||
                0;
    }
    else {
        basePrice = Number(item.selectedSize.price) || 0;
    }
    const ingredients = item.Ingredients || item.ingredients || [];
    const ingredientsPrice = ingredients.reduce((total, ingredient) => {
        if (!ingredient.isDefault && ingredient.quantity > 0) {
            return (total +
                (Number(ingredient.extra_cost_price) || 0) * ingredient.quantity);
        }
        return total;
    }, 0);
    const supplementsPrice = (item.supplements || []).reduce((total, supplement) => {
        const supQuantity = supplement.quantity || 0;
        if (supQuantity > 0) {
            return total + (Number(supplement.extra_cost_price) || 0) * supQuantity;
        }
        return total;
    }, 0);
    const totalPrice = basePrice + ingredientsPrice + supplementsPrice;
    return totalPrice;
}
export function calculateCartSubtotal(items) {
    return items.reduce((sum, item) => sum + (item.totalPrice || 0) * (item.quantity || 1), 0);
}
export function calculateDiscount(subtotal, discountType, discountValue) {
    if (discountType === 'percentage') {
        return (subtotal * discountValue) / 100;
    }
    else {
        return Math.min(discountValue, subtotal);
    }
}
export function calculateVAT(amount, vatRate = 2.6) {
    return Number(((amount * vatRate) / 100).toFixed(2));
}
export function calculateFinalTotal(subtotal, discount, vat, deliveryFee = 0, miscellaneous = 0) {
    const amountAfterDiscount = subtotal - discount;
    const totalWithVAT = amountAfterDiscount + vat;
    return Number((totalWithVAT + deliveryFee + miscellaneous).toFixed(2));
}
